  /*================ FaceBook SDK Factory
   ========================================*/
  angular
  .module('vppApp')
  .factory('FacebookSDKFactory', FacebookSDKFactory);

  FacebookSDKFactory.$inject = ['$http', '$rootScope', '$log', '$window'];

  function FacebookSDKFactory($http, $rootScope, $log, $window) {

    var facebookSDKFactory = {};
    facebookSDKFactory.fbInit = function () {
      console.log("start");
      $window.fbAsyncInit = function () {
        // Executed when the SDK is loaded

        FB.init({
          /*
           The app id of the web app;
           To register a new app visit Facebook App Dashboard
           ( https://developers.facebook.com/apps/ )
           */

          appId: '2087890264859331',
          /*
           Adding a Channel File improves the performance
           of the javascript SDK, by addressing issues
           with cross-domain communication in certain browsers.
           */

          //channelUrl: 'app/channel.html',
          /*
           Set if you want to check the authentication status
           at the start up of the app
           */

          status: true,
          /*
           Enable cookies to allow the server to access
           the session
           */

          cookie: true,
          /* Parse XFBML */

          xfbml: true,
          version: 'v3.2'
        });

        sAuth.watchAuthenticationStatusChange();

      };

      (function (d) {
        // load the Facebook javascript SDK

        var js,
        id = 'facebook-jssdk',
        ref = d.getElementsByTagName('script')[0];

        if (d.getElementById(id)) {
          return;
        }

        js = d.createElement('script');
        js.id = id;
        js.async = true;
        js.src = "//connect.facebook.net/en_US/sdk/debug.js";
        //js.src = "//connect.facebook.net/en_US/sdk.js";

        ref.parentNode.insertBefore(js, ref);

      }(document));
    };
    
    // Educator Share
    facebookSDKFactory.fbGMEDShare = function (shareObj){
      console.log("shareObj", shareObj);
      
      FB.ui(shareObj, function (response) {
        // Debug response (optional)
        console.log(response);
      });
      
    };



    return facebookSDKFactory;
  }
  ;
